import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { North, Popup } from '../../utils/popups';
import { ButtonList, ButtonListItem } from '../ButtonList';
import { ReportIcon } from '../Icon';
import { AbstractPopup } from './AbstractPopup';
function ViewerOptionsPopup({ resolve, ...props }) {
    return (_jsx(ViewerOptionsPopupRoot, { translateFn: North, ...props, children: _jsx(ButtonList, { children: _jsx(ButtonListItem, { asLink: true, href: "https://forms.gle/a1rXpngeEKx53muU6", target: "_blank", rel: "noopener noreferrer", prependComponent: _jsx(ReportIcon, {}), onClick: () => {
                    resolve();
                }, children: "Report" }) }) }));
}
const ViewerOptionsPopupRoot = styled(AbstractPopup) `
    --Popup_Left: 50%;
    --Popup_Top: 50%;
    --Popup_X: -50%;
    --Popup_Y: -50%;
    --Popup_InitialOffsetY: 1rem;
    --Popup_OffsetY: 0;
    --Popup_Background: none;
    --Popup_Border: 0;
    --Popup_Padding: 0;
    --Popup_BorderRadius: 1rem;

    --Popup_Width: 20.75rem;
    --Popup_MaxWidth: calc(var(--vw-100, 100vh) - 2rem);

    @media (min-width: 30rem) {
        --Popup_InitialOffsetX: -50%;
        --Popup_InitialOffsetY: -100%;
        --Popup_OffsetY: calc(-100% - 1rem);
        --Popup_X: max(calc(50% + 1rem), var(--Popup_AnchorX, 0rem));

        --Popup_Left: 0;
        --Popup_Top: 0;
        --Popup_Y: initial;

        /* Setup */
        --Popup_InitialScale: 0.98;
    }
`;
const viewerOptionsPopup = Popup.create(ViewerOptionsPopup);
export function openViewerOptions(options = {}) {
    (async () => {
        try {
            options.onOpenPopup?.();
            await viewerOptionsPopup.pop({
                anchorRef: options.anchorRef,
            });
        }
        catch (_ignore) {
        }
        finally {
            options.onClosePopup?.();
        }
    })();
}
